import computerImg from '../images/Computador.png';

export const Computer = () => {
    return (
        <img
            src={computerImg}
            alt='Computador para colocar variáveis válidas'
            style={{ height: '18vw' }}
        />
    );
};
